<div class="calculator">
    <div class="calculator-header">
        <img class="mr-12" src="./assets/images/new-design-icons/logo/Logo-Crown (white).svg">
        <div class="label">Ипотечный калькулятор</div>
    </div>
    <div class="calculator-content" [formGroup]="calculatorForm">
        <div class="left">
            <div class="input-container">
                <div class="label">Первоначальный взнос</div>
                <div class="input-wrapper">
                    <input
                            class="calc-input"
                            [value]="calculatorForm.get('contribution').value | mask : 'separator.2'"
                            (input)="onInputChange($event, 'contribution')"
                            formControlName="contribution"
                            type="text"
                    />
                    <div class="right-value">₸</div>
                </div>
                <p-slider
                        class="calculator-slider w-full"
                        [min]="selectedCreditProgram.minDownPayment"
                        [step]="100"
                        [max]="selectedCreditProgram.maxDownPayment"
                        formControlName="contribution"
                ></p-slider>
            </div>
            <div class="input-container">
                <div class="label">Срок кредитования</div>
                <div class="input-wrapper">
                    <input
                            (input)="onInputChange($event, 'term')"
                            [value]="calculatorForm.get('term').value"
                            class="calc-input"
                            formControlName="term"
                            type="text"
                    />
                    <div class="right-value">лет</div>
                </div>
                <p-slider class="calculator-slider" [step]="1" [min]="selectedCreditProgram.minCreditPeriod" [max]="selectedCreditProgram.maxCreditPeriod" formControlName="term"/>
            </div>
            <div class="input-container">
                <div class="label">Средний доход в месяц</div>
                <div class="input-wrapper">
                    <input class="calc-input" pInputText (input)="onInputChange($event, 'income')" [value]="calculatorForm.get('income').value | mask : 'separator.2'" formControlName="income" type="text"/>
                    <div class="right-value">₸</div>
                </div>
                <p-slider class="calculator-slider" [min]="0" [step]="100" [max]="300000" formControlName="income"/>
            </div>

            <div class="input-container">
                <div class="label">Программа кредитования</div>
                <app-dropdown
                    [label]="'name'"
                    [value]="'id'"
                    [control]="calculatorForm.get('program')"
                    [options]="creditProgram"
                    [gClass]="'b-8'"
                    (selected)="programSelect($event)"
                ></app-dropdown>
            </div>
        </div>
        <div class="right">
            <div class="section">
                <div class="label">Ежемесячный платёж:</div>
                <div class="value">{{ monthlyPay | mask : 'separator.2' }} ₸</div>
            </div>

            <div class="section mt-24">
                <div class="label">Ставка вознаграждения:</div>
                <div class="value">{{ selectedCreditProgram.percent }} %</div>
            </div>
        </div>
    </div>
</div>
